// extracted by mini-css-extract-plugin
export var adminPrice = "style-module--adminPrice--54568";
export var apply = "style-module--apply--b7413";
export var currency = "style-module--currency--15162";
export var customPrice = "style-module--customPrice--53e95";